import React from 'react';
import { motion } from 'framer-motion';
import { moods } from '../data/habits';
import { useLocale } from '../contexts/LocaleContext';
import { Icon, moodGlyph } from './icons/Icon';
import type { MoodId } from '../types';
interface MoodSelectorProps {
  value: MoodId | null;
  onChange: (mood: MoodId) => void;
}
export function MoodSelector({
  value,
  onChange
}: MoodSelectorProps) {
  const {
    t
  } = useLocale();
  return <div className="flex gap-1" role="radiogroup" aria-label={t('check.mood.title')} data-id="element-1172" data-mp="lz120s8tcpmh">
      {moods.map(mood => {
      const selected = value === mood.id;
      return <motion.button key={mood.id} type="button" role="radio" aria-checked={selected} onClick={() => onChange(mood.id)} whileTap={{
        scale: 0.97
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className={`flex min-h-[64px] min-w-0 flex-1 flex-col items-center justify-center gap-1 rounded-[14px] border px-1 transition-[background-color,border-color] duration-150 ease-brand ${selected ? 'border-gold bg-deep text-sand' : 'border-sand-line bg-white/70 text-deep hover:border-deep/25'}`} data-id="element-1173" data-mp="uz6911a3hm04">
            <Icon name={moodGlyph[mood.id]} size="md" className={selected ? 'text-gold' : 'text-soft'} data-id="element-1174" data-mp="2wg69uvkkwxo6" />
            <span className="w-full truncate text-center text-[9.5px] font-medium leading-tight" data-id="element-1175" data-mp="1zrgvvgc2op7h">
              {t(`mood.${mood.id}`)}
            </span>
          </motion.button>;
    })}
    </div>;
}